import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, opacity = 1, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g transform="translate(3 6)" stroke={color} strokeWidth="2" opacity={opacity} fill="none" fillRule="evenodd">
      <path d="M0 5.75C2.615 2.083 5.781.25 9.5.25c3.719 0 6.885 1.833 9.5 5.5-2.833 3.667-6 5.5-9.5 5.5S2.833 9.417 0 5.75Z" />
      <circle cx="9.5" cy="5.75" r="2.5" />
    </g>
  </svg>
);
